import { SHERLOCK_ACTIONS } from '../types';
import { handleGetContractAnalysisData } from './sherlockActions/contractAnalysis/handleGetContractAnalysis';
import { handleGetTransactionData } from './sherlockActions/decoder/handleGetTransactionData';
import { handleCurrentPage } from './sherlockActions/handleCurrentPage';
import { handleGetTracerData } from './sherlockActions/handleGetTracerData';
import { handleOpenContractAnalysisTab } from './sherlockActions/handleOpenContractAnalysisTab';
import { handleOpenDecoderTab } from './sherlockActions/handleOpenDecoderTab';
import { handleOpenProfilerTab } from './sherlockActions/handleOpenProfilerTab';
import { handleSearchAddress } from './sherlockActions/handleSearchAddress';
import { handleTracerScreenshot } from './sherlockActions/handleTracerScreenshot';
import { handleWait } from './sherlockActions/handleWait';
import { handleGetWalletProfileData } from './sherlockActions/walletProfiler/handleGetWalletProfileData';

// when adding new handlers, remember to update SHERLOCK_ACTIONS definition (hover to check)
export const actionHandlers = {
  [SHERLOCK_ACTIONS.OPEN_PROFILER_TAB]: handleOpenProfilerTab,
  [SHERLOCK_ACTIONS.OPEN_CONTRACT_ANALYSIS_TAB]: handleOpenContractAnalysisTab,
  [SHERLOCK_ACTIONS.OPEN_DECODER_TAB]: handleOpenDecoderTab,
  [SHERLOCK_ACTIONS.SEARCH_ADDRESS]: handleSearchAddress,
  [SHERLOCK_ACTIONS.WAIT]: handleWait,
  [SHERLOCK_ACTIONS.CURRENT_PAGE]: handleCurrentPage,
  [SHERLOCK_ACTIONS.CAPTURE_TRACER_SCREENSHOT]: handleTracerScreenshot,
  [SHERLOCK_ACTIONS.GET_TRACER_DATA]: handleGetTracerData,
  [SHERLOCK_ACTIONS.GET_WALLET_DATA]: handleGetWalletProfileData,
  [SHERLOCK_ACTIONS.GET_TXN_DATA]: handleGetTransactionData,
  [SHERLOCK_ACTIONS.GET_CONTRACT_ANALYSIS_DATA]: handleGetContractAnalysisData,
};
